import {
    ADMIN_ORDER_CHARGES_UPDATE,
    ADMIN_ORDER_CHARGES_UPDATE_FAIL,
    ADMIN_ORDER_CHARGES_UPDATE_SUCCESS,
    ADMIN_ORDER_FINAL_UPDATE,
    ADMIN_ORDER_FINAL_UPDATE_FAIL,
    ADMIN_ORDER_FINAL_UPDATE_SUCCESS,
    ADMIN_ORDER_PACKAGE_NOTES_UPDATE,
    ADMIN_ORDER_PACKAGE_NOTES_UPDATE_FAIL,
    ADMIN_ORDER_PACKAGE_NOTES_UPDATE_SUCCESS,
    ADMIN_ORDER_DETAIL,
    ADMIN_ORDER_DETAIL_FAIL,
    ADMIN_ORDER_DETAIL_SUCCESS,
    ORDER_LIST,
    ORDER_LIST_FAIL,
    ORDER_LIST_SUCCESS,
    ORDER_STATUS_CHANGE,
    ORDER_STATUS_CHANGE_FAIL,
    ORDER_STATUS_CHANGE_SUCCESS,
    GROUP_CART_MONITORING_LIST,
    GROUP_CART_MONITORING_LIST_SUCCESS,
    GROUP_CART_MONITORING_LIST_FAIL,
} from "../../actions/admin/customer-actions";
import { ADMIN_DASHBOARD_COUNT, ADMIN_DASHBOARD_COUNT_FAIL, ADMIN_DASHBOARD_COUNT_SUCCESS } from "../../actions/admin/AdminActions";
import { call, put, takeLatest, } from "redux-saga/effects";
import { API } from "../../api";

function* orderList(action) {
    try {
        const response = yield call(API.orderList, action.payload);
        yield put({ type: ORDER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ORDER_LIST_FAIL, payload: { error: error } });
    }
}

function findOrderInListPayload(payload, id) {
    const root = payload?.data ?? payload;
    const list = Array.isArray(root?.data)
        ? root.data
        : Array.isArray(root?.data?.data)
          ? root.data.data
          : Array.isArray(root)
            ? root
            : [];
    return list.find((o) => String(o?.id) === String(id)) ?? null;
}

function* adminOrderDetail(action) {
    const { id } = action.payload;
    try {
        const response = yield call(API.adminOrderById, id);
        yield put({ type: ADMIN_ORDER_DETAIL_SUCCESS, payload: response.data });
    } catch (error) {
        try {
            const listRes = yield call(API.orderList, {
                search: String(id),
                page: 1,
                limit: 100,
            });
            const found = findOrderInListPayload(listRes?.data, id);
            if (found) {
                yield put({
                    type: ADMIN_ORDER_DETAIL_SUCCESS,
                    payload: { data: found },
                });
                return;
            }
        } catch (_) {
            /* fall through */
        }
        yield put({ type: ADMIN_ORDER_DETAIL_FAIL, payload: { error } });
    }
}

function* adminOrderChargesUpdate(action) {
    const { orderId, charges, onSuccess } = action.payload;
    try {
        const response = yield call(API.adminOrderChargesUpdate, orderId, charges);
        if (typeof onSuccess === "function") {
            onSuccess();
        }
        yield put({
            type: ADMIN_ORDER_CHARGES_UPDATE_SUCCESS,
            payload: {
                orderId,
                message: response.data?.message,
                order: response.data?.data ?? response.data,
                charges,
            },
        });
    } catch (error) {
        yield put({
            type: ADMIN_ORDER_CHARGES_UPDATE_FAIL,
            payload: { error },
        });
    }
}

function* adminOrderFinalUpdate(action) {
    const { orderId, invoiceId, onSuccess } = action.payload;
    try {
        const payload = {};
        if (invoiceId !== undefined) {
            payload.invoice_id = String(invoiceId ?? "").trim();
        }
        const response = yield call(API.adminOrderFinalUpdate, orderId, payload);
        if (typeof onSuccess === "function") {
            onSuccess();
        }
        yield put({
            type: ADMIN_ORDER_FINAL_UPDATE_SUCCESS,
            payload: {
                orderId,
                message: response.data?.message,
                order: response.data?.data ?? response.data,
            },
        });
    } catch (error) {
        yield put({
            type: ADMIN_ORDER_FINAL_UPDATE_FAIL,
            payload: { error },
        });
    }
}

function* adminOrderPackageNotesUpdate(action) {
    const { orderId, package_notes, onSuccess } = action.payload;
    try {
        const response = yield call(API.adminOrderPackageNotesUpdate, orderId, {
            package_notes,
        });
        if (typeof onSuccess === "function") {
            onSuccess();
        }
        yield put({
            type: ADMIN_ORDER_PACKAGE_NOTES_UPDATE_SUCCESS,
            payload: {
                orderId,
                message: response.data?.message,
                order: response.data?.data ?? response.data,
                package_notes,
            },
        });
    } catch (error) {
        yield put({
            type: ADMIN_ORDER_PACKAGE_NOTES_UPDATE_FAIL,
            payload: { error },
        });
    }
}

function* orderStatusChange(action) {
    try {
        const { onSuccess, id, status, payment_status } = action.payload;
        const response = yield call(API.orderStatusChange, action.payload);
        if (typeof onSuccess === "function") {
           onSuccess();
        }
        const updatedOrder = response.data?.data?.data ?? response.data?.data ?? null;
        yield put({
            type: ORDER_STATUS_CHANGE_SUCCESS,
            payload: {
                ...response.data,
                orderId: id,
                orderStatus: updatedOrder?.order_status ?? status ?? null,
                paymentStatus:
                    updatedOrder?.payment_status ?? payment_status ?? null,
            },
        });
    } catch (error) {
        yield put({ type: ORDER_STATUS_CHANGE_FAIL, payload: { error: error } });
    }
}

function* adminDashboardCount() {
    try {
        const response = yield call(API.adminDashboardCount);
        yield put({ type: ADMIN_DASHBOARD_COUNT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: ADMIN_DASHBOARD_COUNT_FAIL, payload: { error: error } });
    }
}

function* groupCartMonitoringList(action) {
    try {
        const response = yield call(API.groupCartMonitoringList, action.payload);
        yield put({ type: GROUP_CART_MONITORING_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: GROUP_CART_MONITORING_LIST_FAIL, payload: { error: error } });
    }
}

function* orderDataSaga() {
    yield takeLatest(ORDER_LIST, orderList);
    yield takeLatest(ADMIN_ORDER_DETAIL, adminOrderDetail);
    yield takeLatest(ADMIN_ORDER_CHARGES_UPDATE, adminOrderChargesUpdate);
    yield takeLatest(ADMIN_ORDER_FINAL_UPDATE, adminOrderFinalUpdate);
    yield takeLatest(ADMIN_ORDER_PACKAGE_NOTES_UPDATE, adminOrderPackageNotesUpdate);
    yield takeLatest(ORDER_STATUS_CHANGE, orderStatusChange);
    yield takeLatest(ADMIN_DASHBOARD_COUNT, adminDashboardCount);
    yield takeLatest(GROUP_CART_MONITORING_LIST, groupCartMonitoringList);
}
export default orderDataSaga;
